import { createRouter, createWebHistory } from "vue-router"
import VueRouteMiddleware from "vue-route-middleware"
import { START_LOCATION } from 'vue-router';


import auth from "@/middleware/auth"
// import authSuperAdmin from "@/middleware/authSuperAdmin"
import authAuditVertexRoles from "@/middleware/authAuditVertexRoles"
import authPublishedPolicyTemplates from "@/middleware/authPublishedPolicyTemplates"

const routes = [
	{
		path: "/",
		name: "index",
		redirect: "main",
		meta: {
			middleware: [auth],
		},
	},

	{
		path: "/validation",
		name: "validation",
		component: () => import("@/views/ValidationPage.vue"),
	},

	{
		path: "/main",
		name: "main",
		component: () => import("@/views/MainPage.vue"),
		meta: {
			middleware: [auth],
		},
		redirect: "dashboard",
		children: [
			{
				path: "/dashboard",
				name: "dashboard",
				component: () => import("@/views/pages/MainDashboard.vue"),
				meta: {
					requiresAuth: true,
				},
				children: [
					{
						path: "tasks/:taskId",
						name: "dashboard-task-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},

			{
				path: "/audits",
				name: "audits",
				component: () => import("@/views/pages/audits/Audits.vue"),
				meta: {
					requiresAuth: true,
				},
				// children: [
					
				// ],
			},
			{
				path: "/evidence-repository",
				name: "evidence_repository",
				component: () => import("@/views/pages/evidence-repository/EvidenceRepository.vue"),
				meta: {
					requiresAuth: true,
				},
				children: [
					{
						path: ":evidenceId",
						name: "evidence-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
					{
						path: "logs",
						name: "evidence-repository-logs",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},
			{
				path: "/policy-templates",
				name: "published_policy_templates",
				component: () => import("@/views/pages/policy-templates/PolicyTemplates.vue"),
				meta: {
					middleware: [authPublishedPolicyTemplates],
				},
			},
			{
				path: "/policy-templates/preview/:policyTemplateId",
				name: "policy_template_preview",
				component: () => import("@/views/pages/policy-templates/PolicyTemplatePreview.vue"),
				props: true,
				meta: {
					middleware: [authPublishedPolicyTemplates],
				},
			},
			{
				path: "/audits/:id",
				name: "audit-view",
				component: () => import("@/views/pages/audits/AuditView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
				children: [
					{
						path: "tasks/:taskId",
						name: "task-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},

					{
						path: "control-groups/:auditControlGroupId/controls/:auditControlId/tasks/:taskId",
						name: "audit-control-task-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: { requiresAuth: true },
					},

					{
						path: "control-groups/:auditControlGroupId/controls/:auditControlId/evidence/:evidenceId",
						name: "audit-control-evidence-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: { requiresAuth: true },
					},

					{
						path: "control-groups/:auditControlGroupId/controls/:auditControlId/locked-evidence/:evidenceId",
						name: "audit-control-locked-evidence-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: { requiresAuth: true },
					},

					{
						path: "evidence/:evidenceId",
						name: "audit-evidence-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
					
					{
						// for evidences linked in a locked audit control
						path: "controls/:auditControlId/evidence/:evidenceId",
						name: "audit-locked-evidence-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},

					{
						path: "control-groups",
						name: "audit-control-group-list",
						component: () => import("@/views/pages/audits/AuditView.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
						children: [
							{
								path: ":auditControlGroupId",
								name: "audit-control-group-view",
								component: () => import("@/views/pages/audits/AuditView.vue"),
								props: true,
								meta: {
									requiresAuth: true,
								},
								children: [
									{
										path: "controls/:auditControlId",
										name: "audit-control-view",
										component: () => import("@/views/pages/audits/AuditView.vue"),
										props: true,
										meta: {
											requiresAuth: true,
										},
										// children: [
										// 	{
										// 		path: "tasks/:taskId",
										// 		name: "audit-control-task-view",
										// 		component: () => import("@/components/catalogue/controls/Sidebar.vue"),
										// 		props: true,
										// 		meta: { requiresAuth: true },
										// 	},
										// 	{
										// 		path: "evidence/:evidenceId",
										// 		name: "audit-control-evidence-view",
										// 		component: () => import("@/components/catalogue/controls/Sidebar.vue"),
										// 		props: true,
										// 		meta: { requiresAuth: true },
										// 	}
										// ]
									}
								]
							},
						]
					},
				],
			},
			{
				path: 'audits/:id/status-summary',
				name: 'audit-control-status-summary',
				component: () => import('@/components/audits/ControlStatusSummary.vue'),
				props: true
			},
			{
				path: "/audits/:id/control-groups",
				name: "audit-controls-tab-view",
				component: () => import("@/views/pages/audits/AuditView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/audits/:id/soa",
				name: "audit-soa-view",
				component: () => import("@/views/pages/audits/AuditView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/audits/:id/reports",
				name: "audit-reports-view",
				component: () => import("@/views/pages/audits/AuditView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/audits/:id/activity-logs",
				name: "audit-activity-view",
				component: () => import("@/views/pages/audits/AuditView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/:orgId/audits/:id",
				name: "audit-view-vtx",
				component: () => import("@/views/pages/audits/AuditView.vue"),
				props: true,
				meta: {
					middleware: [authAuditVertexRoles],
				},
				children: [
					{
						path: "tasks/:taskId",
						name: "task-view-vtx",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},

					{
						path: "control-groups/:auditControlGroupId/controls/:auditControlId/evidence/:evidenceId",
						name: "audit-control-evidence-view-vtx",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: { requiresAuth: true },
					},

					{
						path: "control-groups/:auditControlGroupId/controls/:auditControlId/locked-evidence/:evidenceId",
						name: "audit-control-locked-evidence-view-vtx",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: { requiresAuth: true },
					},

					{
						path: "evidence/:evidenceId",
						name: "audit-evidence-view-vtx",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
					// {
					// 	path: "controls/:auditControlId",
					// 	name: "control-view-vtx",
					// 	component: () => import("@/views/pages/audits/AuditView.vue"),
					// 	props: true,
					// 	meta: {
					// 		requiresAuth: true,
					// 	},
					// },
					{
						path: "control-groups",
						name: "audit-control-group-list-vtx",
						component: () => import("@/views/pages/audits/AuditView.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
						children: [
							{
								path: ":auditControlGroupId",
								name: "audit-control-group-view-vtx",
								component: () => import("@/views/pages/audits/AuditView.vue"),
								props: true,
								meta: {
									requiresAuth: true,
								},
								children: [
									{
										path: "controls/:auditControlId",
										name: "audit-control-view-vtx",
										component: () => import("@/views/pages/audits/AuditView.vue"),
										props: true,
										meta: {
											requiresAuth: true,
										},
										// children: [
										// 	{
										// 		path: "tasks/:taskId",
										// 		name: "audit-control-task-view-vtx",
										// 		component: () => import("@/components/catalogue/controls/Sidebar.vue"),
										// 		props: true,
										// 		meta: { requiresAuth: true },
										// 	},
										// 	{
										// 		path: "evidence/:evidenceId",
										// 		name: "audit-control-evidence-view-vtx",
										// 		component: () => import("@/components/catalogue/controls/Sidebar.vue"),
										// 		props: true,
										// 		meta: { requiresAuth: true },
										// 	}
										// ]
									}
								]
							},
						]
					},

					// {
					// 	path: "evidence/:evidenceId",
					// 	name: "audit-evidence-view-vtx",
					// 	component: () => import("@/components/catalogue/controls/Sidebar.vue"),
					// 	props: true,
					// 	meta: {
					// 		requiresAuth: true,
					// 	},
					// },
				],
			},

			{
				path: "/:orgId/evidence-repository",
				name: "evidence-repository-vtx",
				component: () => import("@/views/pages/evidence-repository/EvidenceRepository.vue"),
				props: true,
				meta: {
					// middleware: [authAuditVertexRoles],
					requiresAuth: true,
				},
				children: [
					{
						path: ":evidenceId",
						name: "evidence-view-vtx",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				]
			},

			{
				path: "/registers",
				name: "registers",
				component: () => import("@/views/pages/registers/Registers.vue"),
				meta: {
					requiresAuth: true,
				}
			},

			{
				path: "/risk-register/:registerId",
				name: "risk-register",
				component: () => import("@/views/pages/registers/RiskRegisters.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
				children: [
					{
						path: "risk/:riskId",
						name: "risk-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},

			{
				path: "/actions-register/:registerId",
				name: "actions-register",
				component: () => import("@/views/pages/registers/ActionsRegister.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
				children: [
					{
						path: "actions/:actionsId",
						name: "actions-register-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},

			{
				path: "/:orgId/actions-register/:registerId",
				name: "actions-register-vtx",
				component: () => import("@/views/pages/registers/ActionsRegister.vue"),
				props: true,
				meta: {
					// middleware: [authAuditVertexRoles],
					requiresAuth: true,
				},
				children: [
					{
						path: "actions/:actionsId",
						name: "actions-register-view-vtx",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},




			

			{
				path: "/risk-methodology/:registerId?",
				name: "risk-methodology",
				component: () => import("@/views/pages/registers/RiskMethodologyExplainer.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				}
			},

			{
				path: "/catalogue/dashboard",
				name: "catalogue_Dashboard",
				component: () => import("@/views/pages/catalogue/Catalogue.vue"),
				meta: {
					// requiresAuth: true,
					middleware: [authAuditVertexRoles],
				},
			},
			{
				path: "/catalogue/controls",
				name: "catalogue_Controls",
				component: () => import("@/views/pages/catalogue/Controls.vue"),
				meta: {
					// requiresAuth: true,
					middleware: [authAuditVertexRoles],
				},
				children: [
					{
						path: ":id",
						name: "control-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},
			{
				path: "/catalogue/actions",
				name: "catalogue_Actions",
				component: () => import("@/views/pages/catalogue/Actions.vue"),
				meta: {
					// requiresAuth: true,
					middleware: [authAuditVertexRoles],
				},
				children: [
					{
						path: ":id",
						name: "action-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},

			{
				path: "/catalogue/controlGroups",
				name: "catalogue_ControlGroups",
				component: () => import("@/views/pages/catalogue/Mapping.vue"),
				meta: {
					// requiresAuth: true,
					middleware: [authAuditVertexRoles],
				},
				children: [
					{
						path: ":id",
						name: "controlGroup-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},

			{
				path: '/catalogue/standards',
				name: 'catalogue_Standards',
				component: () => import("@/views/pages/catalogue/Standards.vue"),
				meta: { requiresAuth: true }
			},

			{
				path: "/catalogue/auditLogs",
				name: "catalogue_AuditLogs",
				component: () => import("@/views/pages/catalogue/Logs.vue"),
				meta: {
					// requiresAuth: true,
					middleware: [authAuditVertexRoles],
				},
				children: [
					{
						path: ":id",
						name: "catalogueAuditLog-view",
						component: () => import("@/components/catalogue/controls/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},

			{
				path: "/catalogue/policy-templates",
				name: "catalogue_PolicyTemplates",
				component: () => import("@/views/pages/catalogue/PolicyTemplates.vue"),
				meta: {
					// requiresAuth: true,
					middleware: [authAuditVertexRoles],
				},
				// children: [
				// 	{
				// 		path: "builder/:policyTemplateId",
				// 		name: "policy_template_editor",
				// 		component: () => import("@/views/pages/policy/PolicyTemplateEditorPage.vue"),
				// 		props: true,
				// 		meta: {
				// 			requiresAuth: true,
				// 		},
				// 	},
				// ],
				children: [
					{
						path: ":policyTemplateId",
						name: "policy_template_view_offcanvas",
						meta: {
							requiresAuth: true,
						},
					},
				],
			},

			{
				path: "/policy-templates/builder/:policyTemplateId",
				name: "policy_template_builder",
				component: () => import("@/views/pages/policy/PolicyTemplateEditorPage.vue"),
				props: true,
				meta: {
					middleware: [authAuditVertexRoles],
					// requiresAuth: true,
				},
			},

			{
				path: "/maintenance-settings/dashboard",
				name: "maintenanceSettings_Dashboard",
				component: () => import("@/views/pages/maint-settings/MaintSettingsDashboard.vue"),
				meta: {
					middleware: [authAuditVertexRoles],
					// requiresAuth: true,
				},
				
				
			},
		],
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach(VueRouteMiddleware({ auth }));

// check if page reload or route have changed
router.beforeEach((to, from) => {
  if (from === START_LOCATION || from.path === '/validation' || from.name === 'validation') {
	sessionStorage.setItem('isPageReload', true);
  } else {
	sessionStorage.setItem('isPageReload', false);
	// if (sessionStorage.getItem('currentTab') != null) { //reset or clear active tab in Audit page if route changed and is not page reload
	// 	sessionStorage.removeItem('currentTab')
	// }
  }
})
export default router;
